import { Transforms, Node, Element, Editor } from 'slate'
import { LIST_TYPES } from './utils'
import { Registry } from '@react-registry'

export const withList = (editor: Editor): Editor => {
  const { normalizeNode } = editor

  editor.normalizeNode = (entry) => {
    const [node, path] = entry
    
    // Remove the 'id' attribute only from the specific list element being normalized
    if (Element.isElement(node) && LIST_TYPES.includes(node?.['type']) && node?.['id'] !== undefined) {
      Transforms.unsetNodes(editor, 'id', { at: path })
      return
    }

    // Call the original normalizeNode
    normalizeNode(entry)
  }

  return editor
}

Registry.register(withList, { id: 'withList', registry: 'v2.plugin' })
